import { createContext, type Context } from 'react';

import { type AuthUser } from '@/schemas/auth-user';

export type UserContextValue = {
  user: AuthUser | null;
  setUser: (data: AuthUser) => void;
  clearUser: () => void;
};

export const UserContext: Context<UserContextValue | null> = createContext<UserContextValue | null>(null);
